import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UpdatesService } from 'src/app/services/updates/updates.service';
import { PromoService } from 'src/app/services/promo/promo.service';
 
const BASE = 'assets/img/moviesphere-plus/landscape/';

@Component({
    selector: 'app-movie-sphere-plus-page',
    templateUrl: './movie-sphere-plus-page.component.html',
    styleUrls: ['./movie-sphere-plus-page.component.scss']
})
export class MovieSpherePlusPageComponent implements OnInit {
    isMobile: boolean = false;

    posters1: string[] = [
        'a-madea-family-funeral', 'ash-vs-evil-dead', 'black-sails',
        'blue-mountain-state', 'clerks2', 'dear-white-people',
        'diary-of-a-mad-black-woman', 'expendables', 'ghost-hunters',
        'love-thy-neighbor', 'madeas-family-reunion', 'redemption', 'saw', 'the-grudge', 'scary-movie4', 'the-freak-brothers',
    ].map(n => `${BASE}${n}.jpg`);

    posters2: string[] = [
        'scary-movie4', 'scream4', 'sorry-to-bother-you',
        'step-up', 'temptation', 'the-blair-witch-project',
        'the-expendables', 'the-freak-brothers', 'the-grudge',
        'the-have-and-the-have-nots', 'warm-bodies', 'zach-and-miri-make-a-porno'
    ].map(n => `${BASE}${n}.jpg`);

    postersRow1: string[] = [...this.posters1]
    postersRow2: string[] = [...this.posters2]
 
    constructor(
        private breakpointObserver: BreakpointObserver,
        private updatesService: UpdatesService,
        private promoService: PromoService
    ) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            this.isMobile = result.matches;
        });
    }

    ngOnInit(): void {}

    onClick() {
        this.updatesService.openUpdates();
    }

    openPromo() {
        this.promoService.openPromo();
    }
}
